import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper';

export const CartIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M14.8 41.7c-.767 0-1.408-.259-1.925-.775-.517-.517-.775-1.158-.775-1.925 0-.767.258-1.408.775-1.925.517-.517 1.158-.775 1.925-.775.767 0 1.408.258 1.925.775.517.517.775 1.158.775 1.925 0 .767-.258 1.408-.775 1.925-.517.517-1.158.775-1.925.775Zm18.4 0c-.767 0-1.408-.259-1.925-.775-.517-.517-.775-1.158-.775-1.925 0-.767.258-1.408.775-1.925.517-.517 1.158-.775 1.925-.775.767 0 1.408.258 1.925.775.517.517.775 1.158.775 1.925 0 .767-.258 1.408-.775 1.925-.517.517-1.158.775-1.925.775Zm-21.6-31 5.5 11.6h14l6.35-11.6H11.6Zm-.7-1.4h28.9l-7.85 14.4H16.2l-3.6 6.6h23.3v1.4H10.15l5.35-9.5L8.1 6.7H4.6V5.3H9l1.9 4Z"
            />
        </svg>
    </IconWrapper>
));
